import type { PillConfig } from '#types/config/components/vf/pill'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    container: 'rounded-full'
  }
} satisfies RecursivePartial<PillConfig>
